import React from "react";
import { BookOpen, ReceiptText, TrendingUp, Banknote, Landmark, LineChart } from "lucide-react";

const FEATURES = [
    { kicker: "01 / LEDGER",   Icon: BookOpen,     title: "Double-entry, always balanced.",         body: "Debits equal credits, or the entry doesn't post. Period locks. Full audit trail. Trial balance, general ledger, day book — one click." },
    { kicker: "02 / GST",      Icon: Landmark,     title: "Native GST end-to-end.",                 body: "GSTR-1, 3B, 2B reconciliation, e-invoicing, e-way bills — natively. No plugins. No third-party bolt-ons. Ready for the 20th." },
    { kicker: "03 / MONEY IN", Icon: ReceiptText,  title: "Invoices customers actually pay.",       body: "Recurring, credit notes, statements. Six-tab template designer. Delivery challans and e-invoice IRN out of the box." },
    { kicker: "04 / MONEY OUT",Icon: Banknote,     title: "Bills, TDS, vendors.",                   body: "Deduct TDS by section automatically from the vendor's default. Vendor credits. Recurring bills for rent, AWS, SaaS." },
    { kicker: "05 / BANK",     Icon: TrendingUp,   title: "Reconcile in minutes, not hours.",       body: "Import statements. AI matches against invoices, bills, journals. Bank rules for recurring descriptions. Reconciled balance in your ribbon." },
    { kicker: "06 / REPORTS",  Icon: LineChart,    title: "P&L, BS, Cash Flow — comparative.",      body: "13-week cash forecast. AR/AP aging. Customer/vendor statements. Drill-down to the journal line that moved the number." },
];

export default function FeatureGrid() {
    return (
        <section className="vy-section" data-testid="landing-features">
            <div className="vy-container">
                <div className="vy-reveal" style={{ marginBottom: 48, textAlign: "center" }}>
                    <div className="vy-kicker">&gt; features.list --all</div>
                    <h2 className="vy-serif vy-h-section" style={{ fontSize: "2.8rem", marginTop: 10, color: "var(--vy-navy)" }}>
                        Six modules. <span className="vy-serif-i">One ledger.</span>
                    </h2>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }} className="vy-grid-3" data-testid="feature-grid">
                    {FEATURES.map((f, i) => {
                        const Icon = f.Icon;
                        return (
                            <div
                                key={f.kicker}
                                className="vy-fcard vy-reveal"
                                data-vy-delay={((i % 3) + 1).toString()}
                                data-testid={"feature-card-" + i}
                            >
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                    <div className="vy-kicker">{f.kicker}</div>
                                    <Icon strokeWidth={1.3} size={18} color="var(--vy-gold)" />
                                </div>
                                <h3 className="vy-serif" style={{ fontSize: 20, marginTop: 12, color: "var(--vy-navy)", lineHeight: 1.25 }}>
                                    {f.title}
                                </h3>
                                <p style={{ marginTop: 10, fontSize: 13.5, color: "var(--vy-muted)", lineHeight: 1.6 }}>
                                    {f.body}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
